import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from '../custom-pipe/SearchPipe';
import { GetTypePipe } from '../custom-pipe/GetTypePipe';
import { KeysPipe } from '../custom-pipe/KeysPipe';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruncatePipe } from '../custom-pipe/TruncatePipe';
// DevExtreme widgets that replaced the MDB components in the templates
// (modals -> dx-popup, mdb-select -> dx-select-box/dx-tag-box, mdb-checkbox -> dx-check-box,
//  mdb-date-picker -> dx-date-box, mdb-file-upload -> dx-file-uploader, mdb-wysiwyg -> dx-html-editor)
import { DxPopupModule, DxSelectBoxModule, DxTagBoxModule, DxCheckBoxModule, DxDateBoxModule, DxFileUploaderModule, DxHtmlEditorModule, DxTabPanelModule, DxChartModule, DxPieChartModule, DxPolarChartModule, DxSchedulerModule } from 'devextreme-angular';
// small local replacements for MDB pieces DevExtreme 21.1 has no equivalent for
import { StepComponent, StepperComponent } from './ui/stepper.component';
import { TablePaginationComponent, TableSortDirective } from './ui/table-pagination.component';
import { ChartComponent } from './ui/chart.component';

const DX_WIDGETS = [DxPopupModule, DxSelectBoxModule, DxTagBoxModule, DxCheckBoxModule, DxDateBoxModule, DxFileUploaderModule, DxHtmlEditorModule, DxTabPanelModule, DxChartModule, DxPieChartModule, DxPolarChartModule, DxSchedulerModule];
const UI = [StepComponent, StepperComponent, TablePaginationComponent, TableSortDirective, ChartComponent];

@NgModule({ declarations: [
        KeysPipe,
        GetTypePipe,
        SearchPipe,
        TruncatePipe,
        ...UI,
    ],
    exports: [
        KeysPipe,
        GetTypePipe,
        SearchPipe,
        TruncatePipe,
        ...UI,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ...DX_WIDGETS,
    ],
    schemas: [NO_ERRORS_SCHEMA], imports: [CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        ...DX_WIDGETS] })
export class MdbGlobalModule { }
